export default "__VITE_ASSET__gkCs7mev__"